import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject, input, signal, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { AngularModule, MaterialModule } from '@shared/modules';
import { TableService } from '../table/table.service';
import { UnsubscribeSubject } from '@shared/interface';
import { actionsUser } from '@constants/actions.constants';
import { RequestForPermissionsDirective } from '@shared/directives/request-for-permissions.directive';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-abm',
  standalone: true,
  templateUrl: './header-abm.component.html',
  styleUrl: './header-abm.component.scss',
  imports: [AngularModule, MaterialModule, RequestForPermissionsDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderAbmComponent implements OnInit, OnDestroy {
  public isVisibleBtnCrear = signal<boolean>(true);

  userActions = actionsUser;

  @Input() permissions: string[] = [];
  @Input() showButtonCreate: boolean = true;
  @Input() redirectBackPath: string = '';
  @Input() specificNavigation: boolean = false;
  @Output() specificNavigationEvent = new EventEmitter<void>();

  public title = input('');
  public button = input('');
  public enableButton = input<boolean>(true);
  public path = input.required();
  public isOla1 = input<boolean>(false);

  // ========== Description ==========
  headerName = input<string>('');
  description = input('');
  pipe = input<string>('|');

  showSpinner = signal<boolean>(false);

  protected readonly unsubscribeAll: UnsubscribeSubject = new Subject<void>();

  // ========== DEPENDENCIES INJECTION ==========
  private readonly _cd = inject(ChangeDetectorRef);
  private readonly _tableSvc = inject(TableService);
  private readonly _router = inject(Router);

  ngOnInit(): void {
    this.spinner();
    this.isVisablTable();
    this.userPermissions();
  }

  navigate() {
    if (this.specificNavigation) {
      this.specificNavigationEvent.emit();
    } else {
      this._router.navigate([this.path()])
    }
  }
  private spinner(): void {
    this._tableSvc.spinner$.subscribe((showSpinner: boolean) => {
      this.showSpinner.set(showSpinner);
      this._cd.markForCheck();
    });
  }

  private isVisablTable(): void {
    this._tableSvc.isVisibleDataTable$.pipe(takeUntil(this.unsubscribeAll)).subscribe((state: Record<string, boolean>[]) => {
      // Valida si el state es null, undefined o si no es un array vacío
      if (!state || !Array.isArray(state) || state.length === 0) {
        return;
      }

      const defaultState = {
        isVisibleBtnCrear: true,
      };

      // Combinar los valores recibidos con los valores por defecto
      const mergedState = state.reduce((acc, curr) => {
        const key = Object.keys(curr)[0];
        acc[key] = curr[key];
        return acc;
      }, defaultState);

      this.isVisibleBtnCrear.set(mergedState['isVisibleBtnCrear']);
      this._cd.markForCheck();
    });
  }

  private userPermissions(): void {
    this._tableSvc.userPermissions$.pipe(takeUntil(this.unsubscribeAll)).subscribe((state: string[]) => {
      // Valida si el state es null, undefined o si no es un array vacío
      if (!state || !Array.isArray(state) || state.length === 0) {
        return;
      }

      // Verifica si el array incluye 'ALTA'
      const isAlta = state.includes('ALTA');
      if (isAlta) {
        this.isVisibleBtnCrear.set(true);
      } else {
        this.isVisibleBtnCrear.set(false);
      }
      this._cd.markForCheck();
    });
  }

  // =============== Para implementar ===============
  // title = input<string>();
  // button = input<string>('');
  // enableButton = input<boolean>(true);
  // path = input<string>();

  // // ========== Description ==========
  // headerName = input<string>('');
  // description = input('');
  // pipe = input<string>('|');

  // showSpinner = signal<boolean>(false);

  // // ========== DEPENDENCIES INJECTION ==========
  // private readonly _cd = inject(ChangeDetectorRef);
  // private readonly _tableSvc = inject(TableService);

  // ngOnInit(): void {
  //   this._tableSvc.spinner$.subscribe((showSpinner: boolean) => {
  //     this.showSpinner.set(showSpinner);
  //     this._cd.markForCheck();
  //   });
  // }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
